import { Container } from 'aurelia-framework';
import { DialogService } from 'aurelia-dialog';
import { UniversalEntitySelect } from '../../../../dialog/universal-entity-select';

const dialogService = Container.instance.get(DialogService);

function getMediaSrc(item) {
    if (!item?.file) return '';
    return item.file.previewUrl
        ? item.file.previewUrl.replace('$width', '1500').replace('$height', '-')
        : item.file.downloadUrl || '';
}

export default (editor, config = {}) => {
    const tm = editor.TraitManager;

    tm.addType('media-library-select', {
        noLabel: true,
        createInput({ trait }) {
            const component = trait.target;
            const componentType = component.get('type');

            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = 'Medien aus der Medienbibliothek auswählen';
            button.className = 'gjs-btn-prim';
            button.style.cssText =
                'width:100%;margin:4px 0;padding:8px 12px;font-size:13px;cursor:pointer;background:#0991b2;color:#fff;border:none;border-radius:4px;';

            button.addEventListener('click', () => {
                const conditions = { type: { $in: ['image'] } };

                dialogService
                    .open({
                        viewModel: UniversalEntitySelect,
                        model: {
                            selectModelId: 'media-database/media-item',
                            conditions,
                            multiSelect: false,
                        },
                    })
                    .whenClosed((data) => {
                        const items = data.output;
                        if (!items || items.length === 0) return;

                        const item = items[0];
                        const src = getMediaSrc(item);
                        if (!src) return;

                        if (componentType === 'image-box') {
                            component.set('background-image', src);
                            component.trigger('change:background-image');
                        } else {
                            component.addAttributes({
                                src,
                                alt: item?.alt ?? '',
                                title: item?.title ?? '',
                            });
                            component.trigger('change:attributes');
                        }
                    });
            });

            return button;
        },
    });
};
